import { isEmpty } from './isEmpty';

export const isValid = (value: any): boolean => {
  if (value === undefined) {
    return false;
  }
  return !isEmpty(value);
};
